import { Component, OnInit } from '@angular/core';
import { BaseService } from '../../base.service';
import { ConfigService } from '../../config.service';

@Component({
  selector: 'app-products',
  templateUrl: './products.component.html',
  styleUrls: ['./products.component.css']
})
export class ProductsComponent implements OnInit {

  showprodform: boolean = false;

  productobj: any = {};
  productdata: any[] = [];
  isEdit: boolean = false;
  SelectedIndex: any = "";
  selectedItem: any = {};

  p: number = 1;

  displayAll:boolean=false;
  itemPerPage: any = 10;

  constructor(public _baseService: BaseService, public _config: ConfigService) { }

  ngOnInit() {
    this.getProducts();
  }


  add_products() {
    let postBody: any = {
      "po_no": this.productobj.po_no,
      "item_code": this.productobj.item_code,
      "item_desc": this.productobj.item_desc,
      "hsn_code": this.productobj.hsn_code,
      "qty": this.productobj.qty,
      "price": this.productobj.price
      // "isAddProduct": true
    };

    if (this.isEdit) {
      postBody.isEditProduct = true;
      postBody.id = this.selectedItem.id;
      let requestURL = this._config.baseURL + this._config.updateProduct;
      let headerOption =  this._baseService.commonheader();

       this._baseService.doPUT(requestURL, postBody, headerOption).subscribe((results: any) => {
        this.productobj = results;
        this.getProducts();

        if(results.message)
        this._baseService.showSuccess(results.message);


        this.showprodform = true;
        // this.productdata[this.SelectedIndex] = this.productobj;
        this.isEdit = false;
        this.showprodform = false;

      });
    }
    else {
      postBody.isAddProduct = true;
      let requestURL = this._config.baseURL + this._config.addProduct;
      let headerOption =  this._baseService.commonheader();
       this._baseService.doPOST(requestURL, postBody, headerOption).subscribe((results: any) => {
        this.productobj = results;
        this.getProducts();

        if(results.message)
        this._baseService.showSuccess(results.message);


        this.productobj = {};
        this.isEdit = false;
        this.showprodform = false;
      });


      // this.productdata.push(this.productobj);
      // this.productobj = {};
      // this.isEdit = false;
      // this.showprodform = false;
    }
  }


  edit_product(item: any) {
    this.showprodform = true;
    this.isEdit = true;
    this.productobj = item;
    debugger;
    this.selectedItem = item;
  }


  delete_procuct(item: any) {
    // this.productdata.splice(index, 1);
    let requestURL = this._config.baseURL + this._config.deleteProduct;
    requestURL = requestURL.replace('{ID}', item.id);
    let headerOption =  this._baseService.commonheader();
     this._baseService.doDELETE(requestURL, headerOption).subscribe((results: any) => {
      this.getProducts();

      if(results.message)
      this._baseService.showSuccess(results.message);


    });
  }

  getProducts() {
    let requestURL = this._config.baseURL + this._config.getProduct;
    let headerOption =  this._baseService.commonheader();
     this._baseService.doGET(requestURL, headerOption).subscribe((results: any) => {
      this.productdata = results.data;
    });

  }
}
